// extracted by mini-css-extract-plugin
module.exports = {"container":"Map_container__2-Tjk","Main":"Map_Main__27IP9"};